/** @jsx jsx */
import React from 'react';
import { css, jsx, SerializedStyles } from '@emotion/core';

const FlexBox: React.FC<{
  alignItems?: 'center'|'flex-start'|'flex-end'; // 適宜増やす
  direction?: 'row'|'column',
  justifyContent?: 'center'|'flex-start'|'flex-end'|'space-between'|'space-around',
  customStyle?: SerializedStyles,
  onClick?: () => void,
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}> = ({
  children, customStyle, alignItems = 'center', direction = 'row', justifyContent, onClick, onMouseEnter, onMouseLeave
}) => (
  <div css={css({
    display: 'flex',
    alignItems,
    justifyContent: justifyContent,
    flexDirection: direction,
  }, customStyle)}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    {children}
  </div>
);

export default FlexBox;
